import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
    padding: theme.spacing(3),
    minHeight: "100vh",
  },
  explorerContainer: {
    backgroundColor: "white",
    borderRadius: "16px",
    minHeight: "700px",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  toolbar: {
    padding: theme.spacing(3),
    borderBottom: "1px solid #e2e8f0",
    background: "white",
    color: "white",
  },
  contentArea: {
    flex: 1,
    padding: theme.spacing(3),
    backgroundColor: "#ffffff",
  },
  footer: {
    padding: theme.spacing(2, 3),
    borderTop: "1px solid #e2e8f0",
    backgroundColor: "#f8fafc",
    textAlign: "center",
  },
  disclaimerText: {
    color: "#64748b",
    fontSize: "0.75rem",
    lineHeight: 1.5,
  },
  professionalCard: {
    borderRadius: "12px",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    cursor: "pointer",
    border: "1px solid #e2e8f0",
    backgroundColor: "#ffffff",
    overflow: "hidden",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
      borderColor: "primary",
    },
  },
  avatarContainer: {
    position: "relative",
    width: "100%",
    height: "200px",
    background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  professionalAvatar: {
    width: "160px",
    height: "160px",
    border: "4px solid white",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  },
  cardContent: {
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(1),
  },
  cardActions: {
    padding: theme.spacing(1, 2, 2, 2),
    justifyContent: "space-between",
    alignItems: "center",
  },
  statusChip: {
    fontSize: "0.75rem",
    height: "24px",
    fontWeight: "600",
    borderRadius: "12px",
  },
  deviceChip: {
    fontSize: "0.7rem",
    height: "20px",
    fontWeight: "500",
    borderRadius: "10px",
    margin: theme.spacing(0.25),
  },
  actionButton: {
    minWidth: "auto",
    padding: theme.spacing(0.5),
    borderRadius: "8px",
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "400px",
    color: "#64748b",
    textAlign: "center",
  },
  searchContainer: {
    padding: theme.spacing(2, 3),
    backgroundColor: "#f8fafc",
    borderBottom: "1px solid #e2e8f0",
  },
  paginationContainer: {
    padding: theme.spacing(2, 3),
    borderTop: "1px solid #e2e8f0",
    backgroundColor: "#f8fafc",
  },
  loadingOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255,255,255,0.8)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  // Header styles
  headerContainer: {
    background: "#092147",
    color: "white",
    padding: "1rem 0",
    marginBottom: "0rem",
    borderRadius: "0px",
    position: "relative",
    overflow: "hidden",
  },
  headerBackground: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "white",
  },
  headerContent: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    color: "#092147",
  },
  headerIcon: {
    fontSize: 30,
    marginBottom: "1rem",
    opacity: 0.9,
  },
  headerTitle: {
    fontWeight: "bold",
    marginBottom: "0.5rem",
  },
  headerSubtitle: {
    opacity: 0.9,
  },
  backButton: {
    borderRadius: "12px",
    textTransform: "none",
    fontWeight: "bold",
    borderColor: "#092147",
    color: "#092147",
    fontSize: "1rem",
  },
  controllerButton: {
    color: "white",
    fontWeight: "bold",
    fontSize: "0.85rem",
    height: "36px",
    borderRadius: "18px",
    textTransform: "none",
    "&:hover": {
      opacity: 0.9,
    },
  },
  refreshButton: {
    "&:disabled": {
      color: "#092147",
    },
  },
  refreshIcon: {
    "&.loading": {
      color: "#092147",
    },
    "&.normal": {
      color: "white",
    },
  },

  // Statistics cards
  statsCard: {
    padding: "0.7rem",
    borderRadius: "16px",
    color: "white",
    textAlign: "center",
  },
  statsCardActive: {
    background: "linear-gradient(135deg, #4CAF50 0%, #45a049 100%)",
  },
  statsCardMaintenance: {
    background: "linear-gradient(135deg, #FF9800 0%, #f57c00 100%)",
  },
  statsCardInactive: {
    background: "linear-gradient(135deg, #f44336 0%, #d32f2f 100%)",
  },
  statsCardTotal: {
    background: "linear-gradient(135deg, #2196F3 0%, #1976d2 100%)",
    padding: "0.5rem",
  },
  statsIcon: {
    fontSize: 30,
    marginBottom: "0.5rem",
  },
  statsNumber: {
    fontWeight: "bold",
  },

  // Loading
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: theme.spacing(5, 0),
  },
  loadingSpinner: {
    color: "#667eea",
  },
  loadingText: {
    marginLeft: "1rem",
  },

  // Device cards
  deviceCard: {
    height: "420px",
    borderRadius: "20px",
    overflow: "hidden",
    transition: "all 0.3s ease-in-out",
    cursor: "pointer",
    position: "relative",
    background: "#ffffff",
    "&:hover": {
      transform: "translateY(-8px) scale(1.02)",
      boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
    },
  },
  deviceCardAction: {
    height: "100%",
  },
  deviceCardHeader: {
    height: "140px",
    background: "linear-gradient(135deg, #092147 0%, #1e3a8a 100%)",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  deviceAvatar: {
    width: 80,
    height: 80,
    backgroundColor: "rgba(255,255,255,0.2)",
    backdropFilter: "blur(10px)",
    border: "2px solid rgba(255,255,255,0.3)",
  },
  deviceAvatarIcon: {
    fontSize: 40,
    color: "white",
  },
  statusBadge: {
    position: "absolute",
    top: "16px",
    right: "16px",
    display: "flex",
    alignItems: "center",
    backgroundColor: "rgba(255,255,255,0.2)",
    backdropFilter: "blur(10px)",
    borderRadius: "20px",
    padding: "6px 12px",
  },
  statusBadgeIcon: {
    fontSize: 16,
    marginRight: "4px",
  },
  statusBadgeText: {
    color: "white",
    fontWeight: "bold",
  },
  connectionBadge: {
    position: "absolute",
    top: "16px",
    left: "16px",
    borderRadius: "12px",
    padding: "4px 8px",
    display: "flex",
    alignItems: "center",
  },
  connectionIcon: {
    fontSize: 12,
    color: "white",
    marginRight: "4px",
    "&.pulse": {
      animation: "$pulse 2s infinite",
    },
  },
  connectionText: {
    color: "white",
    fontWeight: "bold",
  },
  deviceCardContent: {
    padding: "24px",
    height: "calc(100% - 140px - 80px)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  deviceTitle: {
    fontWeight: "bold",
    marginBottom: "8px",
    fontSize: "1.3rem",
    color: "#2c3e50",
  },
  deviceIp: {
    marginBottom: "16px",
    fontFamily: "monospace",
    backgroundColor: "#f8fafc",
    padding: "4px 8px",
    borderRadius: "6px",
    fontSize: "0.8rem",
  },
  deviceInfoRow: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  deviceInfoIcon: {
    fontSize: 18,
    color: "#667eea",
    marginRight: "8px",
  },
  deviceInfoText: {
    fontSize: "0.9rem",
    fontWeight: "500",
  },
  deviceInfoTextSecondary: {
    fontSize: "0.85rem",
  },
  deviceStatusChip: {
    color: "white",
    fontWeight: "bold",
    fontSize: "0.8rem",
    height: "32px",
    borderRadius: "16px",
    "& .MuiChip-icon": {
      fontSize: 18,
      color: "white",
    },
  },

  // Empty states
  emptyStateContainer: {
    padding: "4rem",
    textAlign: "center",
    borderRadius: "20px",
    background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
  },
  emptyStateIcon: {
    fontSize: 80,
    color: "#cbd5e0",
    marginBottom: "2rem",
  },
  emptyStateTitle: {
    marginBottom: "1rem",
    fontWeight: "bold",
  },
  emptyStateSubtitle: {
    marginBottom: "2rem",
  },
  emptyStateButton: {
    backgroundColor: "#667eea",
    color: "white",
    borderRadius: "12px",
    padding: "12px 30px",
    textTransform: "none",
    fontSize: "1rem",
  },

  // No conjunto state
  noConjuntoContainer: {
    display: "flex",
    justifyContent: "center",
    margin: theme.spacing(5, 0),
  },
  noConjuntoPaper: {
    padding: "2rem",
    textAlign: "center",
    borderRadius: "16px",
  },
  noConjuntoIcon: {
    fontSize: 60,
    color: "#ccc",
    marginBottom: "1rem",
  },

  // Dialog styles
  deleteDialog: {
    "& .MuiPaper-root": {
      borderRadius: "16px",
    },
  },
  deleteDialogTitle: {
    backgroundColor: "#ffebee",
    borderRadius: "16px 16px 0 0",
  },
  deleteDialogTitleContent: {
    display: "flex",
    alignItems: "center",
  },
  deleteDialogIcon: {
    color: "#f44336",
    marginRight: "0.5rem",
  },
  deleteDialogContent: {
    padding: "2rem",
  },
  deleteDialogWarning: {
    backgroundColor: "#fff3e0",
    padding: "1rem",
    borderRadius: "12px",
    border: "1px solid #ffcc02",
  },
  deleteDialogActions: {
    padding: "1rem 2rem",
  },
  deleteDialogButton: {
    borderRadius: "8px",
  },
  deleteDialogDeleteButton: {
    backgroundColor: "#f44336",
    borderRadius: "8px",
  },

  // Controller dialog
  controllerDialog: {
    "& .MuiPaper-root": {
      borderRadius: "16px",
    },
  },
  controllerDialogTitle: {
    backgroundColor: "#f5f5f5",
    borderRadius: "16px 16px 0 0",
  },
  controllerDialogTitleContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  controllerDialogTitleLeft: {
    display: "flex",
    alignItems: "center",
  },
  controllerDialogTitleIcon: {
    color: "#092147",
    marginRight: "0.5rem",
  },
  controllerDialogChipGroup: {
    display: "flex",
    gap: theme.spacing(1),
  },
  controllerDialogContent: {
    padding: "2rem",
  },
  controllerCard: {
    borderRadius: "16px",
    border: "3px solid",
  },
  controllerCardActive: {
    borderColor: "#4CAF50",
    background: "linear-gradient(135deg, #e8f5e8 0%, #c8e6c9 100%)",
  },
  controllerCardInactive: {
    borderColor: "#f44336",
    background: "linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)",
  },
  controllerCardContent: {
    padding: "20px",
  },
  controllerCardHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  controllerCardIcon: {
    marginRight: "8px",
    fontSize: 24,
  },
  controllerCardTitle: {
    fontWeight: "bold",
    lineHeight: 1,
  },
  controllerCardInfo: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1.5),
    backgroundColor: "rgba(255,255,255,0.7)",
    borderRadius: "8px",
  },
  controllerCardDevicesList: {
    marginBottom: theme.spacing(2),
  },
  controllerCardDeviceItem: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(0.5),
  },
  controllerCardDeviceDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    marginRight: 8,
  },
  controllerCardDeviceText: {
    fontSize: "0.7rem",
  },
  controllerCardDeviceMore: {
    fontSize: "0.7rem",
  },
  controllerCardFooter: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  controllerStatusChip: {
    color: "white",
    fontWeight: "bold",
  },
  controllerDialogActions: {
    padding: "1rem 2rem",
  },
  controllerDialogCloseButton: {
    borderRadius: "8px",
    backgroundColor: "#092147",
  },

  // Animations
  "@keyframes pulse": {
    "0%": {
      opacity: 1,
    },
    "50%": {
      opacity: 0.5,
    },
    "100%": {
      opacity: 1,
    },
  },
}));




export default useStyles;